import React from "react";
import { Tooltip } from "reactstrap";

export default class TooltipItem extends React.Component {

    state = {
        isOpen: false,
        dropdownOpen: false,
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    render() {

        return (
            <Tooltip
                placement="bottom"
                isOpen={this.state.isOpen}
                target={this.props.id}
                toggle={this.toggle}
            >
                {this.props.content}
            </Tooltip>
        );
    }
}